(function(){
  if (window.AppletonBrooksAliceDatasheet) return;

  var PAGE_URLS = [
    'https://cdn.shopify.com/s/files/1/1017/6498/9302/files/alice-technical-datasheet-page-1.jpg?v=1789887270',
    'https://cdn.shopify.com/s/files/1/1017/6498/9302/files/alice-technical-datasheet-page-2.jpg?v=1789887278'
  ];
  var FILENAME = 'Appleton-Brooks-Alice-Technical-Datasheet.pdf';
  var PAGE_WIDTH = 595.28;
  var PAGE_HEIGHT = 841.89;
  var IMAGE_WIDTH = 1241;
  var IMAGE_HEIGHT = 1754;

  function encodeText(value) {
    return new TextEncoder().encode(value);
  }

  async function getImageBytes(url) {
    var response = await fetch(url, { mode: 'cors', credentials: 'omit' });
    if (!response.ok) throw new Error('Unable to load datasheet page');
    return new Uint8Array(await response.arrayBuffer());
  }

  async function buildPdf() {
    var images = await Promise.all(PAGE_URLS.map(getImageBytes));
    var parts = [];
    var offsets = [];
    var total = 0;

    function addString(value) {
      var bytes = encodeText(value);
      parts.push(bytes);
      total += bytes.byteLength;
    }

    function addBytes(bytes) {
      parts.push(bytes);
      total += bytes.byteLength;
    }

    function beginObject(number) {
      offsets[number] = total;
      addString(number + ' 0 obj\n');
    }

    function endObject() {
      addString('\nendobj\n');
    }

    function addImageObject(number, bytes) {
      beginObject(number);
      addString('<< /Type /XObject /Subtype /Image /Width ' + IMAGE_WIDTH + ' /Height ' + IMAGE_HEIGHT + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + bytes.byteLength + ' >>\nstream\n');
      addBytes(bytes);
      addString('\nendstream');
      endObject();
    }

    function addContentObject(number, imageName) {
      var content = 'q\n' + PAGE_WIDTH + ' 0 0 ' + PAGE_HEIGHT + ' 0 0 cm\n/' + imageName + ' Do\nQ\n';
      var bytes = encodeText(content);
      beginObject(number);
      addString('<< /Length ' + bytes.byteLength + ' >>\nstream\n');
      addBytes(bytes);
      addString('endstream');
      endObject();
    }

    addString('%PDF-1.4\n');

    beginObject(1);
    addString('<< /Type /Catalog /Pages 2 0 R >>');
    endObject();

    beginObject(2);
    addString('<< /Type /Pages /Kids [3 0 R 6 0 R] /Count 2 >>');
    endObject();

    beginObject(3);
    addString('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + PAGE_WIDTH + ' ' + PAGE_HEIGHT + '] /Resources << /XObject << /Im1 4 0 R >> >> /Contents 5 0 R >>');
    endObject();

    addImageObject(4, images[0]);
    addContentObject(5, 'Im1');

    beginObject(6);
    addString('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + PAGE_WIDTH + ' ' + PAGE_HEIGHT + '] /Resources << /XObject << /Im2 7 0 R >> >> /Contents 8 0 R >>');
    endObject();

    addImageObject(7, images[1]);
    addContentObject(8, 'Im2');

    var xrefOffset = total;
    addString('xref\n0 9\n0000000000 65535 f \n');
    for (var i = 1; i <= 8; i++) {
      addString(String(offsets[i]).padStart(10, '0') + ' 00000 n \n');
    }
    addString('trailer\n<< /Size 9 /Root 1 0 R >>\nstartxref\n' + xrefOffset + '\n%%EOF\n');

    return new Blob(parts, { type: 'application/pdf' });
  }

  async function download(button) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Preparing datasheet…';

    try {
      var blob = await buildPdf();
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = FILENAME;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(function(){ URL.revokeObjectURL(url); }, 5000);
    } catch (error) {
      console.error('Alice datasheet download failed', error);
      window.open(PAGE_URLS[0], '_blank', 'noopener');
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ab-alice-datasheet-download]');
    if (!button) return;
    event.preventDefault();
    download(button);
  });

  window.AppletonBrooksAliceDatasheet = { download: download };
})();